<template>
  <div class="d-group text-dark">
    <label class="d-label">Fraværsårsag på personer</label>
    <div class="choose-subject">
      <div class="choose-subject__spinner" v-if="isLoadingSubjects">
        <div class="do-spinner"></div>
      </div>
      <dSelect :items="sortedSubjects" v-else
               :receiveData="theNewSubject"
               :multiple="false"
               :placeholder="$t('vue2.create_activity.search_or_create')"
               :itemSpaceBetween="true"
               @enter="isCreateAbsenceReason = true"
               @update="setSubject"
               @searchText="setTheSearchText"
               @onSearchTextDebounced="onSearchTextDebounced"
               @close="onCloseDSelect">
        <template v-for="(item, index) in sortedSubjects" v-slot:test="slotProps">
          <div class="choose-subject__event_type">
            {{ slotProps.item.vSubjectType }}
          </div>
        </template>
        <div slot="noMatch">
          <h4 class="create-subject-link"
              @click="isCreateAbsenceReason = true">
            + {{ $t('vue2.substitution.create') }}: "{{ theSearchText }}"
          </h4>
        </div>
      </dSelect>
      <div class="icon__bg-circle create-new-subject"
           v-if="isShowCreateSubjectButton"
           v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window'
              }"
           :content='$t("vue2.substitution.create") + ` "` + theSearchText + `" `'
           @click="isCreateAbsenceReason = true">
        <span class="d-icon-plus"></span>
      </div>
    </div>
    <AbsenceReasonsCreate
      v-if="isCreateAbsenceReason"
      :initTitle="theSearchText"
      :reasons="sortedSubjects"
      @create="createAbsenceReason"
      @cancel="isCreateAbsenceReason = false"
    />
  </div>
</template>
<script>
import dSelect from '../../DSelect/DSelect.vue'
import moment from 'moment'
import docendo from '../../../docendo'
import AbsenceReasonsCreate from '../../AbsenceReasons/AbsenceReasonsCreate.vue'
// import eventbus from '../../../eventbus'

export default {
  components: {AbsenceReasonsCreate, dSelect},
  props: {
    calendarId: {
      default: () => 309496
    },
    date: {
      default: () => moment()
    },
    selectedSubject: {
      default: null
    }
  },
  data () {
    return {
      isLoadingSubjects: false,
      subjects: [],
      isSubmitting: false,
      theSearchText: '',
      theNewSubject: null,
      isShowCreateSubjectButton: false,
      theNewlyCreatedSubject: null,
      isCreateAbsenceReason: false
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    filteredSubjects () {
      return this.subjects
    },
    sortedSubjects () {
      return this.filteredSubjects
        .map(subject => {
          // Try to get the translation for 'subject_type'
          const translatedSubjectType = this.$t(`vue2.eventTypes.${subject.subject_type}`)

          // Check if the translation was found or if it returned the same key
          const vSubjectType = translatedSubjectType === `vue2.eventTypes.${subject.subject_type}`
            ? subject.subject_type
            : translatedSubjectType
          // Return the subject with the new property 'v_subject_type'
          return {
            ...subject,
            vSubjectType
          }
        })
        .sort((a, b) => {
          // Sort alphabetically by the 'name' property
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
          return 0
        })
    },
    dbEventStart () {
      let date = moment(this.date).format('YYYY-MM-DD')
      let time = this.startTime.locale('LT')
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    },
    dbEventEnd () {
      let date = moment(this.date).format('YYYY-MM-DD')
      let time = this.endTime.locale('LT')
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    }
  },
  watch: {
    calendarId (val) {
      this.readSubjects()
    },
    theNewlyCreatedSubject (val) {
      this.readSubjects()
    }
  },
  methods: {
    setDate (date) {
      this.$emit('setDate', date)
    },
    onCloseDSelect () {
      this.isShowCreateSubjectButton = false
    },
    setIsShowCreateSubjectButton () {
      const idx = this.filteredSubjects.findIndex(subject => subject.name === this.theSearchText)
      this.isShowCreateSubjectButton = this.theSearchText.length > 0 && idx < 0
    },
    onSearchTextDebounced () {
      this.setIsShowCreateSubjectButton()
    },
    createAbsenceReason (titleAndDefaultPrivate) {
      const title = titleAndDefaultPrivate.title
      const defaultPrivate = titleAndDefaultPrivate.defaultPrivate
      docendo.schoolAbsenceSubjectsCreate(this.schoolId, title, '#564437', defaultPrivate, data => {
        this.$store.commit('subsAddNewAbsenceReason', data)
        this.isCreatingNewSubject = false
        this.theNewlyCreatedSubject = data
        this.theSearchText = ''
        this.readSubjects()
        this.isCreateAbsenceReason = false
      }, failure => {
        console.log('Failed', failure)
      })
      this.$emit('createNewSubject', this.theSearchText)
      this.theSearchText = ''
    },
    setTheSearchText (str) {
      this.theSearchText = str
    },
    setSubject (arr) {
      this.$emit('setSubject', arr[0])
    },
    setStartTime (payload) {
      this.startTime = payload
    },
    setEndTime (payload) {
      this.endTime = payload
    },
    readSubjects () {
      this.isLoadingSubjects = true
      docendo.schoolAbsenceSubjectsList(this.schoolId, false, success => {
        this.isLoadingSubjects = false
        this.subjects = success
        this.$nextTick(_ => {
          if (this.theNewlyCreatedSubject) {
            this.theNewSubject = this.theNewlyCreatedSubject
          }
        })
      }, failure => {
        console.log('something went wrong')
      })
    }
  },
  mounted () {
    this.readSubjects()
    setTimeout(_ => {
      const el = document.querySelector('#d-create-task-for-user .d-select__input-look > input[type="search"]')
      if (el) {
        el.focus()
      }
    }, 400)
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.choose-subject__spinner {
  position: relative;
  pointer-events: none;
  cursor: not-allowed;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 1rem;
  height: 34px;
  width: 100%;
  border-radius: 4px;
  cursor: text;
  border: 1px solid #edf2f7;
  -webkit-appearance: none !important;
  background: #fff;
  box-shadow: 0 2px 5px -1px rgba(50, 50, 93, .25), 0 1px 3px -1px rgba(0, 0, 0, .3);
}

.choose-subject__spinner:before {
  content: 'Søg eller opret';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 9px;
  line-height: 32px;
  color: #757575;
}


.choose-subject {
  position: relative;
}

.create-new-subject {
  position: absolute;
  top: 0.2rem;
  right: -2.6rem;
}

.d-icon-plus {
  font-size: 13px;
}

.d-icon-plus:before {
  content: '+';
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  background-color: rgb(162, 163, 166);
  opacity: 0.6;
}

.create-subject-link {
  background-color: var(--blue) !important;
  color: white;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// OutOfSchoolAbsence.vue?15ec6505